










import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class TooltipSlot extends Vue {
  @Prop() content!: string;

  @Prop() disable?: string;
}

export { TooltipSlot as VbTooltipSlot };
